import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';

/**
 * Mentions legales - Ember (obligation L111-1 Code conso + LCEN).
 */
export function MentionsPage() {
  const navigate = useNavigate();

  return (
    <div className="max-w-2xl mx-auto py-8 px-4 space-y-6">
      <Button variant="ghost" size="sm" onClick={() => navigate(-1)}>
        Retour
      </Button>

      <header className="space-y-2">
        <h1 className="text-3xl font-bold text-primary">Mentions légales</h1>
        <p className="text-sm text-muted-foreground">Dernière mise à jour : 16 mai 2026</p>
      </header>

      <section className="space-y-3">
        <h2 className="text-xl font-semibold">Éditeur du site</h2>
        <ul className="list-none space-y-1">
          <li>
            <strong>Nicolas DODEMANT</strong>, entrepreneur individuel exerçant sous la marque
            commerciale <strong>Black Potion</strong>
          </li>
          <li>Adresse du siège : {'{{ADRESSE}}'}</li>
          <li>SIRET : {'{{SIRET}}'}</li>
          <li>
            Contact :{' '}
            <a href="mailto:kavaliero37@gmail.com" className="text-primary underline">
              {'kavaliero37@gmail.com'}
            </a>
          </li>
        </ul>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-semibold">Directeur de la publication</h2>
        <p>Nicolas DODEMANT</p>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-semibold">Hébergeur</h2>
        <ul className="list-none space-y-1">
          <li>
            <strong>OVHcloud (OVH SAS)</strong>
          </li>
          <li>2 rue Kellermann</li>
          <li>59100 Roubaix - France</li>
          <li>Téléphone : 1007</li>
          <li>
            Site :{' '}
            <a
              href="https://www.ovhcloud.com"
              className="text-primary underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.ovhcloud.com
            </a>
          </li>
        </ul>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-semibold">Nature du service</h2>
        <p>
          Ember est une webapp de jeu de questions et réponses, accessible à l'adresse
          https://emberapp.duckdns.org. Le service est actuellement en{' '}
          <strong>beta gratuite</strong>, réservé aux personnes majeures (18 ans et plus).
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-semibold">Propriété intellectuelle</h2>
        <p>
          L'ensemble des éléments composant le site Ember (textes, questions, design, code source,
          identité visuelle, logo, marque "Ember", marque "Black Potion") est protégé par le droit
          d'auteur et le droit des marques. Ces éléments sont la propriété exclusive de Nicolas
          DODEMANT / Black Potion, sauf mentions contraires.
        </p>
        <p>
          Toute reproduction, représentation, modification, publication, transmission ou adaptation
          totale ou partielle des éléments du site, par quelque procédé que ce soit et sur quelque
          support que ce soit, est interdite sans autorisation écrite préalable.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-semibold">Données personnelles</h2>
        <p>
          Les modalités de collecte et de traitement des données personnelles sont détaillées dans
          notre{' '}
          <a href="/legal/confidentialite" className="text-primary underline">
            Politique de confidentialité
          </a>
          .
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-semibold">Conditions d'utilisation</h2>
        <p>
          L'utilisation du service est soumise à l'acceptation des{' '}
          <a href="/legal/cgu" className="text-primary underline">
            Conditions Générales d'Utilisation
          </a>
          .
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-semibold">Signalement de contenu</h2>
        <p>
          Pour signaler un contenu illicite, abusif ou problématique, ou pour toute question
          relative au service, contacte-nous à{' '}
          <a href="mailto:kavaliero37@gmail.com" className="text-primary underline">
            {'kavaliero37@gmail.com'}
          </a>
          .
        </p>
      </section>
    </div>
  );
}
